import { trimTrailingSlash } from '../app/helpers/general';

const host = import.meta.env.NG_APP_HOST;
const olzaApiUrl = import.meta.env.NG_APP_OLZA_API_URL;
const olzaToken = import.meta.env.NG_APP_OLZA_ACCESS_TOKEN;
const apiUrls = new Map([
  ['en', trimTrailingSlash(import.meta.env.NG_APP_API_URL_EN)],
  ['sk', trimTrailingSlash(import.meta.env.NG_APP_API_URL_SK)],
  ['cs', trimTrailingSlash(import.meta.env.NG_APP_API_URL_CS)],
]);

export const environment = {
  production: true,
  host: trimTrailingSlash(host),
  apiUrls,
  apiUrl: '',
  defaultLocale: 'en',
  storesApiUrl: import.meta.env.NG_APP_STORES_API_URL,
  olzaApiUrl,
  olzaToken,
  isSyneriseEnabled: import.meta.env.NG_APP_SYNERISE_ENABLED === 'true',
  googleApiKey: import.meta.env.NG_APP_GOOGLE_API_KEY,
  packetaApiKey: import.meta.env.NG_APP_PACKETA_API_KEY,
  isYesClubActive: false,
};
